module.exports = __webpack_public_path__ + "static/media/Josi.2d8d316b.png";